import GrayButton from 'ui/GrayButton/GrayButton';
import Text from 'ui/Text/Text';
import Title from 'ui/Title/Title';
import './Partners.scss';
import './PartnersAnim.scss';

const data = [
  require('images/partners/partner-1.png'),
  require('images/partners/partner-1.png'),
  require('images/partners/partner-2.png'),
  require('images/partners/partner-2.png'),
  require('images/partners/partner-2.png'),
];

const Partners: React.FC = () => {
  return (
    <div className="partners section" id="partners">
      <div className="partners__wrapper">
        <ul className="partners__list">
          {data.map((img, id) => (
            <li className="partners__item" key={id}>
              <img src={img} alt="partner" />
            </li>
          ))}
        </ul>
      </div>
      <div className="container partners__container">
        <Title className="partners__title">Our Partners</Title>
        <Text className="partners__text">
          Ecosystem Allies: Powering Progress. Uniting for Blockchain
          Innovation.
        </Text>
        {/* <GrayButton className="start-btn partners__btn">
          <div className="start-btn__img">
            <img src={require('images/sphere-journey.png')} alt="sphere" />
          </div>
          <span className='start-btn__text'>Start Now</span>
        </GrayButton> */}
      </div>
    </div>
  );
};

export default Partners;
